import React, { useContext } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

import { useAccessesStore } from "../../../../core/stores/AccessesStore";
import { useRequestHeaders } from "../../../../core/hooks/useRequestHeaders";
import { AuthContext } from "../../../../core/providers/AuthContext";

export default function ReturnToDefaultDialog({
  open,
  handleReturnToDefaultDialog,
}) {
  const { t } = useTranslation();
  const REQUEST_HEADERS = useRequestHeaders();
  const { logout } = useContext(AuthContext);

  const { returnToDefaultDashboard } = useAccessesStore((state) => ({
    returnToDefaultDashboard: state.returnToDefaultDashboard,
  }));

  const handleAccept = () => {
    returnToDefaultDashboard({
      t,
      REQUEST_HEADERS,
      logout,
    });
    handleReturnToDefaultDialog(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => handleReturnToDefaultDialog(false)}
      aria-labelledby="return-to-default-dialog"
    >
      <DialogTitle id="return-to-default-dialog">
        {t("CUSTOM_HOME_RESTORE_DIALOG_TITLE")}
      </DialogTitle>
      <DialogContent>{t("CUSTOM_HOME_RESTORE_DIALOG_CONTENT")}</DialogContent>
      <DialogActions>
        <Button onClick={handleAccept}>{t("YES")}</Button>
        <Button onClick={() => handleReturnToDefaultDialog(false)}>
          {t("FORM_CANCEL")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
